import { render } from "./About.vue?vue&type=template&id=58e92eee"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"

import "./About.vue?vue&type=style&index=0&id=58e92eee&lang=scss"
script.render = render

export default script